import { c as _c } from "react/compiler-runtime";
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { Checkbox } from 'platform/components';
import { Icon } from 'platform/foundation-tw';
import type { EagColumn } from '../../../../../../types/EagColumn';
import type { EagColumnState } from '../../../../../../types/EagColumnState';
export type SortableColumnItemProps = {
  column: EagColumn;
  columnState: EagColumnState;
  onSetHidden: (key: string, hidden: boolean) => void;
  columnHidingAllowed: boolean;
  isDragDisabled: boolean;
};
export function SortableColumnItem(props) {
  const $ = _c(28);
  let t0;
  if ($[0] !== props.column.key) {
    t0 = {
      id: props.column.key
    };
    $[0] = props.column.key;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable(t0);
  const isVisible = !(props.columnState.hidden ?? false);
  let t1;
  if ($[2] !== transform) {
    t1 = CSS.Transform.toString(transform);
    $[2] = transform;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = isDragging ? 0.5 : 1;
  let t3;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== transition) {
    t3 = {
      transform: t1,
      transition,
      opacity: t2
    };
    $[4] = t1;
    $[5] = t2;
    $[6] = transition;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const dragStyle = t3;
  let t4;
  if ($[8] !== props) {
    t4 = value => {
      props.onSetHidden(props.column.key, !value);
    };
    $[8] = props;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleCheckboxChange = t4;
  let t5;
  if ($[10] !== attributes || $[11] !== listeners || $[12] !== props.isDragDisabled) {
    t5 = props.isDragDisabled ? {} : {
      ...attributes,
      ...listeners
    };
    $[10] = attributes;
    $[11] = listeners;
    $[12] = props.isDragDisabled;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const dragHandleProps = t5;
  const dragCursorClass = props.isDragDisabled ? "cursor-default" : "cursor-grab";
  const t6 = `${dragCursorClass} text-gray-400 flex-shrink-0`;
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Icon value="other/drag" size={4} />;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== dragHandleProps || $[16] !== t6) {
    t8 = <span className={t6} {...dragHandleProps}>{t7}</span>;
    $[15] = dragHandleProps;
    $[16] = t6;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const t9 = !props.columnHidingAllowed;
  let t10;
  if ($[18] !== handleCheckboxChange || $[19] !== isVisible || $[20] !== props.column.headerName || $[21] !== t9) {
    t10 = <div className="flex-1 min-w-0"><Checkbox label={props.column.headerName} value={isVisible} onChange={handleCheckboxChange} isDisabled={t9} /></div>;
    $[18] = handleCheckboxChange;
    $[19] = isVisible;
    $[20] = props.column.headerName;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== dragStyle || $[24] !== setNodeRef || $[25] !== t10 || $[26] !== t8) {
    t11 = <div ref={setNodeRef} style={dragStyle} className="flex items-center gap-2 py-1.5 hover:bg-gray-50 rounded px-4">{t8}{t10}</div>;
    $[23] = dragStyle;
    $[24] = setNodeRef;
    $[25] = t10;
    $[26] = t8;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  return t11;
}